import { render } from "./person-real-detail.vue?vue&type=template&id=b2df3284"
import script from "./person-real-detail.vue?vue&type=script&lang=js"
export * from "./person-real-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__